import { StrapiImage } from "types/image";

export const getStrapiImagePath = (image: StrapiImage | undefined) => {
  if (!image?.url) {
    // return placeholder image
    return "/hero.png";
  }
  // Strip trailing slash — Strapi 5 rejects `//uploads/...` with 400 "Malicious Path".
  const base = process.env.NEXT_PUBLIC_STRAPI_URL?.replace(/\/+$/, "") ?? "";
  return `${base}${image.url}`;
};
